<template>
  <read-artist :name-route="nameRoute"/>
</template>

<script>
import ReadArtist from '../../../components/artist/read-artist'
export default {
  name: 'ReadArtistView',
  components: {
    ReadArtist
  },
  data () {
    return {
      nameRoute: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.nameRoute = from.name
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/artist/read-artist.view.vue